module.exports = __webpack_public_path__ + "media/newstyle/images/card-icon-2-98e422e112df4fbff875ed4454e79033.svg";